import Vue from "vue";
import "vant/lib/index.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { Lazyload } from "vant";
import {
  Button,
  Col,
  Row,
  Cell,
  CellGroup,
  Icon,
  Toast,
  List,
  Tab,
  Tabs,
  Dialog,
  Empty,
  Image as VanImage,
  Badge,
  Form,
  Field,
  Picker,
  Popup,
  Uploader,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  Rate,
  DropdownMenu,
  DropdownItem,
  Tag,
  Swipe,
  SwipeItem,
  Calendar,
  Divider,
  Overlay,
  ImagePreview,
  Search,
  NoticeBar,
  Step,
  Steps,
  Loading,
  NavBar,
  Sticky,
  PullRefresh,
} from "vant";

Vue.config.productionTip = true;

Vue.use(Col);
Vue.use(Row);
Vue.use(Button);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(List);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Dialog);
Vue.use(Empty);
Vue.use(VanImage);
Vue.use(Badge);
Vue.use(Form);
Vue.use(Field);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Uploader);
Vue.use(Rate);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Tag);
Vue.use(Calendar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
Vue.use(Divider);
Vue.use(Overlay);
Vue.use(ImagePreview);
Vue.use(Search);
Vue.use(NoticeBar);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Loading);
Vue.use(NavBar);
Vue.use(Sticky);
Vue.use(PullRefresh);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
